import React from 'react';

import classes from './MasonryCard.module.scss';

interface MasonryCardProps {
  children: React.ReactNode;
}

/**
 * A wrapper component for each Masonry item.
 * Takes care of grid spacing automatically.
 */
export const MasonryCard = ({ children }: MasonryCardProps) => {
  return <div className={classes.container}>{children}</div>;
};
